const base = {
	searchBarMain: {
		searchButton: {
			label: 'Suchen',
		},
		travelType: {
			hotelOnly: 'Nur Hotel',
			package: 'Pauschalreise',
			cruise: 'Kreuzfahrten',
		},
	},
	delete: 'Löschen',
	close: 'Schließen',
	alternativeFlights: {
		currentOffer: 'Originalflug',
	},
	filtersSection: {
		dealsOnly: {
			title: 'Restplätze',
			label: 'Angebote mit Preissenkung',
		},
	},
	showMoreToggle: {
		more: 'Mehr anzeigen',
		less: 'Weniger anzeigen',
	},
	filterTagList: {
		more: 'Alle Filter anzeigen',
		less: 'Weniger Filter anzeigen',
		deleteAll: 'Alle löschen',
		selectedFilter: 'Ausgewählte Filter',
	},
	flightDetail: {
		header: 'Voraussichtliche Flugdaten',
		legalText:
			'Der Reiseveranstalter behält sich Änderungen der geplanten Flugzeiten im Rahmen der gesetzlichen und vertraglichen Möglichkeiten vor.',
	},
	button: {
		ok: 'Übernehmen',
		cancel: 'Verwerfen',
		abort: 'Abbrechen',
		reset: 'Zurücksetzen',
		showRegion: 'Alle Regionen anzeigen',
	},
	calendar: {
		confirmDialog: {
			title: 'Möchten Sie die Auswahl verwerfen?',
		},
		daysOfWeek: {
			monday: 'Montag',
			tuesday: 'Dienstag',
			wednesday: 'Mittwoch',
			thursday: 'Donnerstag',
			friday: 'Freitag',
			saturday: 'Samstag',
			sunday: 'Sonntag',
		},
	},
	offers: {
		title: 'Angebote',
		packageDeals: 'Pauschalreise-Angebote',
		hotelOffers: 'Hotelangebote',
	},
	pricing: {
		surcharge: 'Aufpreis',
		discount: 'Abschlag',
		total: 'Gesamtpreis',
	},
	offer: {
		details: 'Angebotsdetails',
		verifyOffer: 'Angebot prüfen',
		notAvailable: 'Nicht mehr verfügbar',
		addToCart: 'Zur Buchung',
		flight: {
			details: 'Flugdetails',
			stops: 'Direktflug | {stop} Stop | {stop} Stops',
		},
	},
	airportFilter: {
		title: 'Abflughafen',
		modalTitle: 'Flughafen',
		notFoundMessage: 'Für deine Suche gibt es leider keine passenden Filter.',
	},
	dropdownFilterType: {
		select: '{title} auswählen',
	},
	any: 'Beliebig',
	destination: {
		label: 'Reiseziel, Hotel, Ort, ...',
		modal: {
			searchInput: 'Suchen',
			searchHistory: 'Zuletzt gesucht',
			favouriteDestinations: 'Beliebteste Destinationen',
			countries: 'Land',
			hotels: 'Hotel',
			cities: 'Stadt',
			regions: 'Region',
			regionGroups: 'Destinationen',
		},
	},
	autocomplete: {
		airportLabels: {
			ownArrival: 'Eigene Anreise',
			departure: 'Flug ab ',
			flightIncluded: 'Inkl. Flug',
		},
		travelers: '{travelers} Erwachsener | {travelers} Erwachsene',
		children: '{children} Kind | {children} Kinder',
		errorMessage: {
			serverError: 'Der Server ist im Augenblick nicht erreichbar.',
			noResult: 'Bitte geben Sie einen Suchbegriff ein.',
			tryAgain: 'Bitte versuchen Sie es in Kürze erneut.',
		},
	},
	formField: {
		min: '(mind.)',
	},
	traveler: {
		adult: '{count} Erwachsener | {count} Erwachsene',
		adultShort: 'Erw.',
		adultLabel: 'Erwachsener | Erwachsene',
		childLabel: 'Kind | Kinder',
		child: '{count} Kind | {count} Kinder',
	},
	common: {
		year: '{count} Jahr | {count} Jahre',
	},

	travelersField: {
		childAge: 'Alter der Kinder bei der Rückreise',
		childDecreaseLabel: 'Ein Kind entfernen',
		childIncreaseLabel: 'Ein Kind hinzufügen',
		adultDecreaseLabel: 'Einen Erwachsenen entfernen',
		adultIncreaseLabel: 'Einen Erwachsenen hinzufügen',
		helperText: 'Standardmäßig wird nur 1 Zimmer gebucht. Wünschen Sie mehrere Zimmer, rufen Sie uns bitte unter',
		infantsWarning: 'Kinder unter 2 Jahren haben keinen Anspruch auf einen eigenen Sitzplatz im Flieger.',
		title: 'Reisende',
		youngerThanTwo: 'jünger als 2 Jahre',
	},
	offerDuration: {
		label: 'Zeitraum',
		earliestArrival: 'Früheste Anreise',
		latestDeparture: 'Späteste Abreise',
		maxDurationErrorMessage: 'Die gewählte Dauer kann nicht länger als 56 Tage sein. Bitte ändern Sie die Reisedaten.',
	},
	travelDuration: {
		label: 'Dauer',
		exact: 'Exakt wie angegeben',
		rangeInField: '{range} Tage',
		range: '{min}-{max} Tage',
		day: '{day} Tag | {day} Tage',
		exactText: 'genau',
		resultExactText: 'Exakt',
		daysText: 'Tage',
		flexible: 'Beliebig',
		errorMessage: 'Die gewählte Dauer ist zu lang für den eingestellten Zeitraum. Möchten Sie die Reisedaten ändern?',
	},
} as const;

export type BaseStructure = typeof base;

export default base;
